import React from "react";
import "./css/UnsupportedBrowser.css"; // external CSS
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
const UnsupportedBrowser = () => {
  return (
    <>
   <div className="unsupport">
     <Navbar/>
    <div className="unsupported-container container">
      <h1>Browser Not Supported</h1>
      <p>
        It looks like you are using an outdated or unsupported browser (e.g., Internet Explorer or Phoenix).  
        For the best experience, please upgrade to a modern and updated browser such as:
      </p>
      <ul>
        <li>Google Chrome</li>
        <li>Mozilla Firefox</li>
        <li>Microsoft Edge</li>
        <li>Safari</li>
      </ul>
      <p>We value your experience and security 🌍</p>
    </div>
   </div>
   <Footer/>
    </>
  );
};

export default UnsupportedBrowser;
